import React from 'react'

import { BaseContent } from '@fourthwall/components'

import * as S from './BlogLink.styled'

type BlogLinkProps = {
  title: string
  description: string
  href: string
  thumbnail: string
}

export const BlogLink = ({ title, description, thumbnail, href }: BlogLinkProps) => (
  <S.Container href={href} target="_blank" rel="noreferrer">
    <S.Thumbnail>
      <S.ThumbnailImage src={thumbnail} alt={`${title} thumbnail`} />
    </S.Thumbnail>
    <div>
      <div>
        <BaseContent size="small">
          <strong>{title}</strong>
        </BaseContent>
      </div>
      <S.Description>
        <BaseContent size="small" appearance="secondary">
          {description}
        </BaseContent>
      </S.Description>
    </div>
  </S.Container>
)
